import React, { useState, useEffect } from 'react';
import SharedFooter from '../SharedFooter';
import './Contact.css';

const FORMSUBMIT_URL = 'https://formsubmit.co/greenwavetech17@gmail.com';

function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('submitted') === '1') {
      setSubmitted(true);
      window.history.replaceState({}, '', window.location.pathname + window.location.hash);
    }
  }, []);

  return (
    <div className="page-wrap page-layout">
      <section className="contact-page">
        <div className="contact-inner">
          <h1 className="contact-title anim-page-enter">Contact Us</h1>
          <p className="contact-intro anim-page-enter anim-delay-1">
            Get in touch with the Digilync team. Whether you are a farmer, service provider, 
            industrial buyer, or partner, we would like to hear from you.
          </p>

          <div className="contact-extra anim-page-enter anim-delay-2">
            <p>
              Digilync connects smallholder farmers with mechanization providers and industrial buyers 
              across Cameroon. Our platform uses geospatial intelligence and AI to match supply with 
              demand, reduce post-harvest loss, and improve livelihoods. We support farmers through 
              WhatsApp-based registration and booking, and help providers reach new customers.
            </p>
            <p>
              Use the form below to ask questions, request a demo, or discuss partnerships. 
              For urgent support, reach us on WhatsApp.
            </p>
          </div>

          <div className="contact-grid">
            <div className="contact-info anim-page-enter anim-delay-3">
              <h3>Reach Us</h3>
              <p><strong>Email:</strong> contact@digilync.com</p>
              <p><strong>WhatsApp:</strong> +237 678 699 886</p>
              <p className="contact-info-note">
                For fastest response, start a conversation on WhatsApp. 
                Farmers and providers can register directly via our WhatsApp bot.
              </p>
            </div>

            <form
              className="contact-form anim-page-enter anim-swipe-right anim-delay-4"
              action={FORMSUBMIT_URL}
              method="POST"
            >
              <input type="hidden" name="_subject" value="Digilync Contact Form" />
              <input type="hidden" name="_replyto" value={form.email} />
              <input type="hidden" name="_next" value={`${window.location.origin}${window.location.pathname || '/'}?submitted=1#footer`} />
              <input type="text" name="_honey" style={{ display: 'none' }} tabIndex="-1" autoComplete="off" />
              <h3>Send a Message</h3>
              {submitted && (
                <p className="contact-form-success">Thank you. Your message has been sent. We will get back to you soon.</p>
              )}
              <div className="contact-form-field">
                <label htmlFor="contact-name">Name</label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  placeholder="Your name"
                  value={form.name}
                  onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
                  required
                />
              </div>
              <div className="contact-form-field">
                <label htmlFor="contact-email">Email</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  placeholder="your@email.com"
                  value={form.email}
                  onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                  required
                />
              </div>
              <div className="contact-form-field">
                <label htmlFor="contact-message">Message</label>
                <textarea
                  id="contact-message"
                  name="message"
                  placeholder="Your message..."
                  rows={5}
                  value={form.message}
                  onChange={(e) => setForm((f) => ({ ...f, message: e.target.value }))}
                  required
                />
              </div>
              <button type="submit" className="contact-form-submit">Send Message</button>
            </form>
          </div>
        </div>
      </section>
      <SharedFooter />
    </div>
  );
}

export default Contact;
